












import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialForm from '@/classes/MaterialForm';

@Component
export default class DetailsMaterialForm extends Vue {
    @Prop({default: new MaterialForm({})}) public item!: MaterialForm;
}
